import { API_BASE_URL, API_FETCH_EXAM_RESULT_PER_ORG_PATH } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export interface ExamResultPerOrgObject {
    orgName: string;
    data: {
        classRoomName: string;
        data: {
            studentName: string;
            examUuids: {
                uuid: string;
                end_at: string; // ISO date string representing the end date
            }[];
        }[];
    }[];
}

async function executeGetFetchExamPerOrgResultWithToken(accessToken: string | null): Promise<ExamResultPerOrgObject> {
    return axios
        .get(
            API_BASE_URL + API_FETCH_EXAM_RESULT_PER_ORG_PATH,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else if (error.response && error.response.status === 400) {
                console.log("user does not belong to any org or does not have permission to view this data");
            } else if (error.response && error.response.status === 404) {
                console.log("no one took exams yet");
            } else {
                console.error('Error during fetching:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetFetchExamPerOrgResultWithToken(accessToken: string | null): Promise<ExamResultPerOrgObject> {

    return executeGetFetchExamPerOrgResultWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetFetchExamPerOrgResultWithToken(accessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
